import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  Input,
  OnInit,
  Optional,
  SimpleChanges,
} from '@angular/core';
import { DIALOG_DATA } from '../../../../global.variable';
import { DialogRef } from '../modal-dialogue/modal-dialogue.ref';
import { AppService } from '../../../app.service';
import { ToasterService } from '../../services/toaster.service';
import { FileUploadComponent } from '../file-upload/file-upload.component';
import { ModalDialogueService } from '../modal-dialogue/modal-dialogue.service';
import { MediaPreviewComponent } from '../media-preview/media-preview.component';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'gtapp-prompter',
  templateUrl: './prompter.component.html',
  styleUrl: './prompter.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PrompterComponent implements OnInit {
  @Input() promptData: any = [];
  @Input() preview: boolean = false;
  selectedPagePrompts: any = [];
  page: number = 0;

  requiredField: any;
  constructor(
    @Optional() protected dialogRef: DialogRef,
    @Inject(DIALOG_DATA) public dialogueData: any,
    private cdr: ChangeDetectorRef,
    private dialogService: ModalDialogueService,
    private toasterService: ToasterService,
    private appService: AppService,
  ) {}

  ngOnInit(): void {
    if (this.dialogueData) {
      this.promptData = this.dialogueData?.promptData;
      this.preview = this.dialogueData?.preview;
    }

    if (this.promptData?.length) {
      this.selectedPagePrompts = this.promptData[0];
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (this.promptData?.length) {
      this.selectedPagePrompts = this.promptData[0];
    }
  }

  changePagination(next = true) {
    this.page = next ? this.page + 1 : this.page - 1;
    if (this.page <= this.promptData?.length)
      this.selectedPagePrompts = this.promptData[this.page];
  }
  selectCheckBox(field: any, option: any) {
    if (field?.value?.includes(option)) {
      field.value = field?.value?.filter((item: any) => item !== option);
    } else {
      if (field?.value?.length < field?.allowedSelections) {
        field.value.push(option);
      } else {
        field?.value?.shift();
        field.value.push(option);
      }
    }
  }

  getSubOptions(field: any) {
    return (
      field?.options?.find((item: any) => item?.key == field?.value)
        ?.selectSubOptions || []
    );
  }
  closeDalog(value?: any) {
    this.dialogRef?.close(value);
  }
  validatepage() {
    return Boolean(
      this.getRequiredFieldWithoutValue([this.selectedPagePrompts]),
    );
  }
  valdiateForm() {
    this.requiredField = this.getRequiredFieldWithoutValue(this.promptData);

    return Boolean(this.requiredField);
  }

  getRequiredFieldWithoutValue(promptData: any): string | null {
    function nestedConditionCheck(val: any, key: string) {
      if (Array.isArray(val)) {
        return val?.includes(key);
      } else {
        return key === val;
      }
    }
    function processObject(obj: any): string | null {
      if (obj.required) {
        if (!obj.value?.length && !obj?.file_id) {
          return obj.promptLabel || obj.field || obj?.file_id;
        }

        if (obj?.options?.length) {
          for (const subOption of obj.options) {
            if (
              subOption?.selectSubOptions?.length &&
              nestedConditionCheck(obj?.value, subOption?.key)
            ) {
              for (const item of subOption?.selectSubOptions) {
                const result = processObject(item);
                if (result) {
                  return result;
                }
              }
            }
          }
        }
      }
      return null;
    }

    for (const pagePrompt of promptData) {
      for (const item of pagePrompt) {
        const result = processObject(item);

        if (result) {
          return result;
        }
      }
    }
    return null;
  }

  savePromtData() {
    let savedData: any = [];
    for (const item of this.promptData) {
      savedData.push(...this.getValues(item));
    }

    this.dialogRef?.close(savedData);
  }
  getValues(data: any) {
    const pageData: any = [];
    for (const innerItem of data) {
      if (innerItem.type === 'input') {
        if (!(innerItem?.value || innerItem?.file_id)) continue;
        let data: any = {
          description: innerItem.description,
          value: innerItem.value,
          show_in_reports: innerItem.showInReports,
        };
        if (innerItem?.file_id) {
          data.file_id = innerItem?.file_id;
        }

        const options = innerItem.options || [];

        const saveOptions: any = [];
        for (const optionItem of options) {
          if (optionItem.selectSubOptions?.length) {
            saveOptions.push(...this.getValues(optionItem.selectSubOptions));
          }
        }

        if (saveOptions.length > 0) {
          data.options = saveOptions;
        }
        pageData.push(data);
      }
    }
    return pageData;
  }
  removeFileFromPrompt(field: any) {
    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: 'Delete Photo?',
      },
    });
    dialogRef.afterClosed().subscribe((value) => {
      if (value === true) {
        field.fileUrl = null;
        field.file_id = null;
        field.status = null;
        this.cdr.detectChanges();
      }
    });
  }
  openCamPopup(field: any) {
    const dailogRef = this.dialogService.open(FileUploadComponent, {
      data: {
        showFrom: 'mobileForm',
      },
    });
    dailogRef.afterClosed().subscribe((value: any) => {
      if (value && value !== 'error') {
        if (!value?.actualFileUpload) {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: 'Please add a photo',
          });
        } else {
          field.status = 'Uploading';
          field.fileUrl = value?.fileUrl;
          this.cdr.detectChanges();
          if (this.preview) {
            field.file_id = 'previeId';
            field.status = 'Success';
            this.cdr.detectChanges();
            return;
          }

          let fileData: FormData = new FormData();

          fileData.append('file', value?.actualFileUpload);

          let url = `manage_s3_files`;

          fileData.append('image_source', value?.uploadType);

          if (value?.exifData && Object.values(value?.exifData)?.length) {
            fileData.append('exif_data', JSON.stringify(value?.exifData));
          }
          this.appService.formDataApi(url, fileData).then((resp: any) => {
            if (resp?.status === 'success') {
              field.file_id = resp?.data?.id;
              field.status = 'Success';
              this.cdr.detectChanges();
            } else {
              field.status = 'Failed';
              this.cdr.detectChanges();
              this.toasterService.setMessage({
                successMessage: '',
                errorMessage: resp['message'],
              });
            }
          });
        }
      } else if (value == 'error') {
        this.toasterService.setMessage({
          errorMessage: 'Unable to access your camera',
        });
      }
    });
  }
  onOpenFile(file: any) {
    this.dialogService.open(MediaPreviewComponent, {
      data: { mediaSrc: file?.fileUrl },
    });
  }
}
